import React from 'react';
import { Box } from '@mui/material';

const LoaderOverlay = ({ open = false, message }) => {
  if (!open) return null;

  // If another LoaderOverlay instance already rendered the spinner image,
  // avoid rendering the image again to prevent duplicate icons.
  const isImageAlreadyRendered =
    typeof document !== 'undefined' &&
    !!document.querySelector('img[data-loader-image="true"]');

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.65)',
        zIndex: 2000,
        backdropFilter: 'blur(1px)',
      }}
    >
      {!isImageAlreadyRendered && (
        <Box
          component="img"
          data-loader-image="true"
          src="/loaderlogo-removebg-preview.png"
          alt="Loading"
          sx={{
            width: { xs: 18, sm: 26 },
            height: 'auto',
            animation: 'spin 3s linear infinite',
            animationDirection: 'normal',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
          }}
        />
      )}
      {message && (
        <Box
          component="span"
          sx={{
            marginTop: 2,
            fontSize: 14,
            color: '#555',
            letterSpacing: '0.5px',
          }}
        >
          {message}
        </Box>
      )}
    </Box>
  );
};

export default LoaderOverlay;

